
import React from 'react';
import { motion } from 'framer-motion';

const WhyNowSection = () => {
  const reasons = [
    {
      title: "Policy Pressure",
      description: "Budget accountability and outcomes measurement are driving unprecedented focus on value-based metrics.",
      color: "from-morgenDarkCharcoal/20 to-morgenDarkCharcoal/5",
      number: "01"
    },
    {
      title: "AI Maturity",
      description: "Generative AI and LLMs have evolved to meet healthcare's regulatory and contextual requirements.",
      color: "from-morgenBlue/20 to-morgenBlue/5",
      number: "02"
    },
    {
      title: "Care Gaps",
      description: "Critical health interactions occur between appointments, creating opportunities for targeted intervention.",
      color: "from-morgenViolet/20 to-morgenViolet/5",
      number: "03"
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-morgenDarkCharcoal">Why Now</h2>
          <p className="text-xl text-gray-700 max-w-2xl mx-auto">
            The convergence of policy, technology, and care delivery innovation has created 
            the perfect environment for Morgen's platform approach.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {reasons.map((reason, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className={`rounded-xl p-8 relative overflow-hidden bg-gradient-to-br ${reason.color} border border-gray-200 hover:shadow-md transition-shadow`}
            >
              <div className="absolute top-4 right-4 text-4xl font-bold opacity-20">{reason.number}</div>
              <div className="relative z-10">
                <h3 className="text-2xl font-bold mt-4 mb-3 text-morgenDarkCharcoal">{reason.title}</h3>
                <p className="text-gray-700">{reason.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyNowSection;
